import { IExportInterfaceFieldValueReplacementEntryDTO } from "src/app/base/models/models.swagger.generated";

export interface IValueChangedInfo {
  id: number;
  newValue: string;
}

export interface IFieldValueReplacementEntry {
  id: number; // list editor adds negative values for ids that are created in the UI
  sourceValue: string | null;
  replacementValue: string | null;
  origSourceValue: string | null;
  origReplacementValue: string | null;
}

export class FieldValueReplacementEntry implements IFieldValueReplacementEntry {
  public id: number;
  public sourceValue: string;
  public replacementValue: string;
  public origSourceValue: string | null;
  public origReplacementValue: string | null;

  constructor(value: IFieldValueReplacementEntry | IExportInterfaceFieldValueReplacementEntryDTO) {
    if(value) {
      this.id = value.id;
      this.sourceValue = value.sourceValue;
      this.replacementValue = value.replacementValue;

      if((value as IFieldValueReplacementEntry).origSourceValue != undefined) {
        this.origSourceValue = (value as IFieldValueReplacementEntry).origSourceValue;
        this.origReplacementValue = (value as IFieldValueReplacementEntry).origReplacementValue;
      } else {
        this.origSourceValue = value.sourceValue;
        this.origReplacementValue = value.replacementValue;
      }
    }
  }
}
